import type { NewsItem } from "@/types";

export const newsList: NewsItem[] = [
  {
    id: "news-1",
    title: "《仙剑奇侠传》播出二十周年：一代人的仙侠启蒙为何始终无可替代",
    category: "新闻",
    date: "2025-01-18",
    summary:
      "从余杭镇的少年到南诏国的宿命，二十年过去，这部剧依旧是一代人心中仙侠题材的起点与标杆。",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20editorial%20image%2C%20ancient%20jade-green%20mountain%20and%20cloud%20sea%20with%20faint%20golden%20light%2C%20floating%20sword%20silhouette%2C%20soft%20mist%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20serene%20mystical%20atmosphere&width=800&height=520&seq=news-1&orientation=landscape",
    content: [
      "二十年前，一部改编自同名游戏的电视剧悄然播出，却意外开启了中国仙侠剧的黄金时代。少年李逍遥、女娲后人赵灵儿、侠女林月如之间的宿命纠葛，成为一代观众共同的青春记忆。",
      "这部剧最动人之处，不在于华丽的特效，而在于它对「情」与「义」的细腻刻画。无论是爱情、友情还是责任，都被编织进旅途的每一次抉择之中。",
      "二十年后回望，它依旧是仙侠题材绕不开的起点。对许多观众而言，仙侠世界的想象，正是从那个余杭镇的少年推开木门的那一刻开始的。",
    ],
  },
  {
    id: "news-2",
    title: "《仙剑奇侠传三》剧情深度解读：为何说它是一部关于「执念」的作品",
    category: "剧情解读",
    date: "2025-02-03",
    summary:
      "五灵珠、邪剑仙、三世情缘……剥开寻仙的外壳，这部剧真正的主角其实是人心中的执念。",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20editorial%20image%2C%20ancient%20immortal%20temple%20gate%20wreathed%20in%20jade-green%20mist%20with%20glowing%20golden%20runes%2C%20floating%20lanterns%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20serene%20mystical%20atmosphere&width=800&height=520&seq=news-2&orientation=landscape",
    content: [
      "《仙剑奇侠传三》表面上是景天一行人寻找五灵珠、封印邪剑仙的冒险故事，但它的内核远比剧情更为幽深。",
      "景天对安稳生活的向往、雪见对自由的渴望、长卿对师门的忠诚、紫萱三世不悔的痴情——每个人都在为自己的执念奔走。而邪剑仙，恰恰是被无数执念汇聚而成的存在。",
      "剧集最终给出的答案温柔而克制：真正能颠倒众生的，从来不是仙术与法宝，而是愿为所爱之人直面命运的那份心意。",
    ],
  },
  {
    id: "news-3",
    title: "角色访谈｜从赵灵儿到紫萱：仙剑系列女主角为何总能成为观众意难平",
    category: "角色访谈",
    date: "2025-02-20",
    summary:
      "善良、坚韧、敢爱敢恨——仙剑系列中的女性角色，为何能穿越时间，成为观众心中难以磨灭的印记。",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20editorial%20image%2C%20a%20flowing%20white%20and%20jade-green%20ancient%20dress%20floating%20among%20petals%20and%20mist%2C%20soft%20golden%20light%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20serene%20mystical%20atmosphere&width=800&height=520&seq=news-3&orientation=landscape",
    content: [
      "在仙剑系列的群像中，女性角色往往承担着最动人、也最沉重的部分。赵灵儿的牺牲、林月如的痴守、紫萱的三世不悔，构成了系列最令人念念不忘的记忆。",
      "她们并非只是男主角故事的陪衬，而是各自拥有完整成长弧光的独立个体。她们的勇气与抉择，构成了仙侠世界最有温度的那一面。",
      "正是这种对人物深度与情感重量的尊重，让仙剑系列的女主角们，能够穿越岁月，成为一代又一代观众心中永恒的「意难平」。",
    ],
  },
  {
    id: "news-4",
    title: "《仙剑奇侠传四》剧集改编引热议：经典如何与新一代观众相遇",
    category: "新闻",
    date: "2025-03-08",
    summary:
      "当成长叙事遇上全新世代，云天河、韩菱纱们的故事被重新讲述，也带来了关于改编尺度与审美的新讨论。",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20editorial%20image%2C%20ancient%20jade-green%20forest%20path%20leading%20toward%20a%20glowing%20moon%20gate%20in%20the%20mist%2C%20golden%20light%20beams%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20serene%20mystical%20atmosphere&width=800&height=520&seq=news-4&orientation=landscape",
    content: [
      "《仙剑奇侠传四》的剧集化，让许多老玩家与新一代观众的目光再次汇聚到这段关于成长与寻仙的故事上。",
      "比起前作，这一代的叙事更强调少年的天真与理想主义。云天河对世界的纯粹好奇，与韩菱纱的机灵果敢，形成了鲜明的对照。",
      "改编永远是一场与经典的对话。如何在尊重原作精神的同时，让它被新一代观众真正读懂，是每一部经典改编都要回答的问题。",
    ],
  },
  {
    id: "news-5",
    title: "剧情解读｜《古剑奇谭》中的命运与反抗：屠苏为何让人如此心疼",
    category: "剧情解读",
    date: "2025-03-22",
    summary:
      "身负剑灵之力的少年，一生都在与命运抗争。这样的角色弧光，为何总能击中观众内心最柔软的地方。",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20editorial%20image%2C%20a%20giant%20glowing%20sacred%20tree%20in%20a%20misty%20jade-green%20forest%20with%20golden%20spirit%20orbs%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20serene%20mystical%20atmosphere&width=800&height=520&seq=news-5&orientation=landscape",
    content: [
      "百里屠苏这个角色之所以动人，是因为他从一开始就被剥夺了选择的权利。命运将剑灵之力强加于他，也将孤独与误解一并交给了他。",
      "但他从未真正放弃。哪怕被全世界误解，他依旧选择守护心中珍视之人。这种「知命而不认命」的姿态，正是角色最迷人的地方。",
      "所谓仙侠，从来不只是飞升与长生。它讲述的，永远是人在命运面前如何做出自己的选择。",
    ],
  },
  {
    id: "news-6",
    title: "角色访谈｜霍建华与胡歌：仙侠剧中「一人分饰多角」的表演魅力",
    category: "角色访谈",
    date: "2025-04-05",
    summary:
      "从徐长卿到白子画，从李逍遥到宇文拓，那些跨越不同作品、不同性格的角色，成就了仙侠剧独特的人物群像。",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20editorial%20image%2C%20two%20elegant%20ancient%20robes%20of%20jade-green%20and%20pale%20gold%20hanging%20before%20a%20misty%20mountain%20window%2C%20soft%20light%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20serene%20mystical%20atmosphere&width=800&height=520&seq=news-6&orientation=landscape",
    content: [
      "仙侠剧的魅力，很大程度上来自演员与角色之间的相互成就。同一个演员，在不同作品里塑造出性格迥异的人物，本身就是一种独特的观赏乐趣。",
      "有人偏爱清冷克制的道门弟子，有人钟情亦正亦邪的复杂角色。角色的多面性，让仙侠剧的人物群像格外丰满。",
      "正是这些鲜活的角色，让观众在剧集之外，依然愿意一遍遍地回味那个属于仙侠的世界。",
    ],
  },
  {
    id: "news-7",
    title: "盘点｜近年最受欢迎的仙侠剧人物设定趋势",
    category: "剧情解读",
    date: "2025-04-19",
    summary:
      "从清冷仙尊到傲娇魔尊，从纯粹少年到复杂反派，仙侠剧的人物设定正在发生哪些有趣的变化。",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20editorial%20image%2C%20floating%20glowing%20jade-green%20and%20golden%20magical%20orbs%20above%20a%20misty%20mountain%20lake%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20serene%20mystical%20atmosphere&width=800&height=520&seq=news-7&orientation=landscape",
    content: [
      "近年的仙侠剧在人物设定上，越来越倾向于「反差感」。冷硬外壳下的深情、强大身份背后的孤独，都成为观众津津乐道的看点。",
      "与此同时，纯粹而明亮的少年角色也重新受到欢迎。他们代表着一份不被世俗磨灭的理想主义，给故事带来温暖的底色。",
      "无论是哪一种设定，能被记住的角色，往往都拥有足够立体的动机与成长弧光。",
    ],
  },
  {
    id: "news-8",
    title: "官方活动｜仙侠主题线下观影会启动，经典剧集重返大银幕",
    category: "新闻",
    date: "2025-05-02",
    summary:
      "一场以经典仙侠剧为主题的线下观影活动正式启动，让粉丝得以在银幕上重温那些难忘的名场面。",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20editorial%20image%2C%20a%20grand%20ancient%20jade-green%20pavilion%20lit%20by%20warm%20golden%20lanterns%20at%20dusk%2C%20misty%20mountains%20behind%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20serene%20mystical%20atmosphere&width=800&height=520&seq=news-8&orientation=landscape",
    content: [
      "为了让经典仙侠剧被更多人重温，一场仙侠主题线下观影活动正式启动。活动将精选多部经典剧集的代表性片段，与粉丝一同回顾那些难忘的瞬间。",
      "现场还将设置角色立牌、剧照展区与粉丝留言墙，营造沉浸式的仙侠氛围，让观众得以走进那个心中的江湖。",
      "对许多粉丝而言，走进影院重新看到熟悉的故事，本身就是一次与青春的温柔重逢。",
    ],
  },
  {
    id: "news-9",
    title: "剧情解读｜《苍兰诀》：一部用「选择」写成的情书",
    category: "剧情解读",
    date: "2025-05-16",
    summary:
      "仙与魔、爱与义、救赎与牺牲——《苍兰诀》以明快的节奏，讲述了一个关于选择的深情故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20editorial%20image%2C%20a%20majestic%20dark%20jade-green%20palace%20among%20misty%20peaks%20with%20glowing%20golden%20fire%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20dramatic%20mystical%20atmosphere&width=800&height=520&seq=news-9&orientation=landscape",
    content: [
      "《苍兰诀》最打动人的地方，是它把「选择」放在了故事的中心。小兰花与东方青苍的每一次靠近，都是一次对既有立场的突破。",
      "仙与魔的界限在这里被重新审视。真正定义一个人的，从来不是出身，而是他愿意为谁做出怎样的选择。",
      "正因为这份坦诚与明亮，它成为近年仙侠题材中一部格外清新的作品。",
    ],
  },
];